/**
 * useInvitations Hook
 *
 * React Query hook for fetching the list of pending invitations for a tenant.
 */

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { userService } from '../../../api/user.service';
import type { InvitationSanitized } from '../../../types/user.types';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for fetching pending invitations list
 */
export const useInvitations = (
  tenantId: string
): UseQueryResult<InvitationSanitized[], Error> => {
  return useQuery<InvitationSanitized[], Error>({
    queryKey: ['invitations', tenantId],
    queryFn: async () => {
      console.log('[useInvitations] Fetching invitations for tenant:', tenantId);
      return await userService.listInvitations(tenantId);
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      console.error('[useInvitations] Failed to fetch invitations:', getErrorMessage(error));
    },
  });
};
